import React from "react";

const MailingList = () => {
  return (
    <section className="spettacolo__info-wrapper">
      <div className="spettacolo__address-wrapper">
      <div className="spettacolo__info-line">
        <span className="spettacolo__info-text">
          Eckersbergs gate 18b
          <br />
          0266 Oslo
          <br />
          By appointment only
        </span>
      </div>
      <div className="spettacolo__info-line">
        <a
          href="mailto:info@spettacolooslo.com"
          className="spettacolo__info-text"
        >
          info@spettacolooslo.com
        </a>
      </div>
      </div>
      <div className="spettacolo__mailer-wrapper">
        <div className="spettacolo__info-line">
          <span className="spettacolo__info-text">MAILING LIST</span>
        </div>
        <div id="mc_embed_shell">
          <div id="mc_embed_signup">
            <form
              action="https://spettacolooslo.us15.list-manage.com/subscribe/post?u=f48e1a6384b1ad245bbc65843&amp;id=d0d82d1547&amp;f_id=00e3c2e1f0"
              method="post"
              id="mc-embedded-subscribe-form"
              name="mc-embedded-subscribe-form"
              class="validate"
              target="_self"
              novalidate=""
            >
              <div id="mc_embed_signup_scroll">
                <div class="mc-field-group">
                  <input
                    type="email"
                    name="EMAIL"
                    class="required email"
                    id="mce-EMAIL"
                    required=""
                    defaultValue=""
                    placeholder="Email Address:"
                  />
                </div>
                <div id="mce-responses" class="clear">
                  <div
                    class="response"
                    id="mce-error-response"
                    style={{ display: "none" }}
                  ></div>
                  <div
                    class="response"
                    id="mce-success-response"
                    style={{ display: "none" }}
                  ></div>
                </div>
                <div
                  aria-hidden="true"
                  style={{ position: "absolute", left: "-5000px" }}
                >
                  <input
                    type="text"
                    name="b_f48e1a6384b1ad245bbc65843_d0d82d1547"
                    tabindex="-1"
                    defaultValue=""
                  />
                </div>
                <div class="clear">
                  <input
                    type="submit"
                    name="subscribe"
                    id="mc-embedded-subscribe"
                    class="button"
                    value="SUBSCRIBE"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MailingList;
